import React, { SVGProps } from 'react'

import MeasurIcon from './MeasurIcon'

export default class IconBriefcase extends MeasurIcon<SVGProps<SVGSVGElement>> {
  render() {
    return (
      <svg
        width="20"
        height="20"
        viewBox="0 0 20 20"
        fill="none"
        stroke="currentColor"
        xmlns="http://www.w3.org/2000/svg"
        {...this.props}
      >
        <path
          d="M16.6667 5.83334H3.33334C2.41286 5.83334 1.66667 6.57953 1.66667 7.5V15.8333C1.66667 16.7538 2.41286 17.5 3.33334 17.5H16.6667C17.5871 17.5 18.3333 16.7538 18.3333 15.8333V7.5C18.3333 6.57953 17.5871 5.83334 16.6667 5.83334Z"
          strokeWidth="1.66667"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
        <path
          d="M13.3333 17.5V4.16667C13.3333 3.72464 13.1577 3.30072 12.8452 2.98816C12.5326 2.67559 12.1087 2.5 11.6667 2.5H8.33334C7.89131 2.5 7.46739 2.67559 7.15483 2.98816C6.84227 3.30072 6.66667 3.72464 6.66667 4.16667V17.5"
          strokeWidth="1.66667"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
      </svg>
    )
  }
}
